module.exports = new __parcel__URL__("tx.bf8999f2.png").toString();